import { connect } from 'react-redux';
import { uiselector, profileSelector } from '../selector';
import Price from '../components/price';
import FilterSlider from '../components/filter/filterSlider';

export default connect(
  (state, { prices }) => {
    const profile = profileSelector(state);
    const { showPrices } = uiselector('showPrices')(state);
    if (!profile) return null;
    return { price: prices[profile.customer_price_list], showPrices };
  },
  null
)(Price);

export const ConnectedPriceSlider = connect(
  state => {
    const { showPrices } = uiselector('showPrices')(state);
    return {
      show: showPrices,
    };
  },
  null
)(FilterSlider);



// WEBPACK FOOTER //
// ../shop_main/containers/price.js